export default "__VITE_ASSET__D7g_1UfM__"